import { call,put, select } from "redux-saga/effects";
import { removeIncomingCallSaga } from "../../callSessions/removeIncomingCall/removeIncomingCall";

export function* ignoreCallSaga(action) {
    const callSession = action.payload;
    
    try {
        callSession.ignore();

        // Remove the call from incomingCalls
        yield call(removeIncomingCallSaga, { payload: callSession.id });

        console.log("Call ignored successfully");
    } catch (error) {
        console.error("Error ignoring call:", error);
    }


}